// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vytd","left":"styles_left__1jflr"};